if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
            const _this = this;
            setTimeout(_this.initSlider(), 100);
          });
      }

      initSlider() {
          //Product page option frames changer
          $('.option-framing label').on('click',function(){
              $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing #' + $(this).attr('for')).data('url') + ")");
          });
          if ($('.option-framing input:checked').length > 0) {
              $('.main-product-gallery div:not(.other) .card__media').css('background-image', "url(" +  $('.option-framing input:checked').data('url') + ")");
          }

          //Product page option frames size wall preview
          $('.option-print-size label').on('click',function(){
              $('.main-product-gallery .slide-wall-preview').attr('data-frame-size',  $('.option-print-size #' + $(this).attr('for')).data('frame-size'));
          });
          if ($('.option-print-size input:checked').length > 0) {
              $('.main-product-gallery .slide-wall-preview').attr('data-frame-size',  $('.option-print-size input:checked').data('frame-size'));
          }

          if ($('.main-product-gallery').length > 0) {
            setTimeout(function(){
              //Product page main slider
              $('.main-product-gallery').slick({
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  fade: false,
                  asNavFor: '.main-thubnails',
                  responsive: [
                      {
                          breakpoint: 767,
                          settings: {
                              slidesToShow: 1,
                              dots: true
                          }
                      }
                  ]
              });
              //Product page main slider thumbnails
              $('.main-thubnails').slick({
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  asNavFor: '.main-product-gallery',
                  dots: false,
                  centerMode: true,
                  focusOnSelect: true
              });
              if (window.matchMedia("(max-width: 767px)").matches) {
                  $('.main-thubnails').slick('unslick');
              }
            }, 50);
          }

          $('#anti-glare').change(function() {
              $('.js-cb-framing-swatch-container label').removeClass('pseudo-checked-swatch');

              if (this.checked) {
                  $('#anti-glare').attr('checked', "true");
                  $('#anti-glare').prop('checked', true);

                  let selectedFramingSwatch = $('input[type="radio"][name="Framing"]:checked');
                  if (selectedFramingSwatch.length === 1) {
                      let framingContainer = $(selectedFramingSwatch).parents('.js-cb-framing-swatch-container');

                      if (framingContainer.length === 1) {
                          let framingHandle = $(framingContainer).data('framing_swatch');

                          let antiGlareFramingContainer = $('.js-cb-framing-swatch-container[data-framing_swatch="' + framingHandle + ' Anti-Glare' + '"]');
                          if (antiGlareFramingContainer.length === 1) {
                              $(selectedFramingSwatch).removeAttr('checked');
                              $(selectedFramingSwatch).prop('checked', false);

                              $(antiGlareFramingContainer).find('label').click();
                              $(framingContainer).find('label').addClass('pseudo-checked-swatch');
                          }
                      }
                  }
              } else {
                  document.getElementById(`anti-glare`).removeAttribute('checked');
                  $('#anti-glare').removeAttr('checked');
                  $('#anti-glare').prop('checked', false);

                  let selectedFramingSwatch = $('input[type="radio"][name="Framing"]:checked');
                  if (selectedFramingSwatch.length === 1) {
                      let framingContainer = $(selectedFramingSwatch).parents('.js-cb-framing-swatch-container');

                      if (framingContainer.length === 1) {
                          let framingHandle = $(framingContainer).data('framing_swatch');

                          let antiGlareFramingContainer = $('.js-cb-framing-swatch-container[data-framing_swatch="' + framingHandle.replace(' Anti-Glare', '') + '"]');

                          if (antiGlareFramingContainer.length === 1) {
                              $(selectedFramingSwatch).removeAttr('checked');
                              $(selectedFramingSwatch).prop('checked', false);

                              $(antiGlareFramingContainer).find('label').click();
                          }
                      }
                  }
              }
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, variant-radios, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
